module.exports = "pegasus/assets/themelp1/small/50.png";